import { GoogleDocumentContext, GoogleDocumentMetadataModel } from "@plugins/google/types.ts";

interface GoogleDocumentData {
  title: GoogleDocumentMetadataModel["title"];
  mimeType: GoogleDocumentMetadataModel["type"];
  sourceDocumentId: GoogleDocumentMetadataModel["documentId"];
  status: GoogleDocumentMetadataModel["status"];
  createdBy: GoogleDocumentMetadataModel["createdBy"];
}

interface GoogleDocumentStoreState {
  lesson: Record<number, GoogleDocumentData>;
  attempt: Record<number, GoogleDocumentData>;
  processingGoogleFiles: string[];
  sourceDocumentIdInModal: string;
}

export interface GoogleDocumentStoreType {
  state: GoogleDocumentStoreState;
  getGoogleDocument: (context: GoogleDocumentContext, id: string) => GoogleDocumentData;
  getGoogleDocumentByField: (
    context: GoogleDocumentContext,
    id: string,
    field: string,
  ) => string | number;
  checkProcessingGoogleFilesByIdList: (idList: string[]) => boolean;
  getSourceDocumentIdInModal: () => string;
  setSourceDocumentIdInModal: (documentId: string) => void;
  addProcessingGoogleFile: (id: string) => void;
  removeProcessingGoogleFile: (id: string) => void;
  setGoogleDocument: (
    context: GoogleDocumentContext,
    id: number,
    googleDocument: GoogleDocumentData,
  ) => void;
  setGoogleDocumentByField: <T>(
    context: GoogleDocumentContext,
    id: number,
    field: string,
    data: T,
  ) => void;
  removeGoogleDocument: (context: GoogleDocumentContext, id: number) => void;
}

const googleDocumentStore: GoogleDocumentStoreType = {
  //  Google document format
  //  googleDocumentById: {
  //    title: "",
  //    mimeType: "",
  //    sourceDocumentId: "",
  //    status: ""
  //  }
  // context: lesson / attempt
  // field: title / mimeType / sourceDocumentId / status
  state: {
    lesson: [],
    attempt: [],
    processingGoogleFiles: [], //for attempt side use only, to disable clear answer

    // Use to store the document id when the modal is open when duplication is done for editing team member.
    // To cater for scenario when document A is duplicating, and GoogleDuplicationWaitModal is opening for document B.
    sourceDocumentIdInModal: "",
  },
  getGoogleDocument(context, id) {
    if (this.state[context] && this.state[context][id]) {
      return this.state[context][id];
    }
  },
  getGoogleDocumentByField(context, id, field) {
    if (this.state[context] && this.state[context][id]) {
      return this.state[context][id][field];
    }
  },
  checkProcessingGoogleFilesByIdList(idList) {
    for (const id of idList) {
      if (this.state.processingGoogleFiles.includes(id)) {
        return true;
      }
    }
    return false;
  },
  getSourceDocumentIdInModal() {
    return this.state.sourceDocumentIdInModal;
  },
  setSourceDocumentIdInModal(documentId) {
    this.state.sourceDocumentIdInModal = documentId;
  },
  addProcessingGoogleFile(id) {
    this.state.processingGoogleFiles.push(id);
  },
  removeProcessingGoogleFile(id) {
    const index = this.state.processingGoogleFiles.indexOf(id);
    if (index > -1) {
      this.state.processingGoogleFiles.splice(index, 1);
    }
  },
  setGoogleDocument(context, id, googleDocument) {
    this.state[context][id] = googleDocument;
  },
  setGoogleDocumentByField(context, id, field, data) {
    this.state[context][id][field] = data;
  },
  removeGoogleDocument(context, id) {
    delete this.state[context][id];
  },
};

export default googleDocumentStore;
